/* Produktblad, templates/product.produktblad.liquid */
/* Ladda ner PDF: ritar .page till en bild (html2canvas) och lägger den på en A4-sida (jsPDF).
   Ger alltid exakt en sida, oberoende av webbläsarens utskriftsinställningar (t.ex. på mobil).
   Samma bibliotek och versioner som temats tidigare produktblad (global.min.js). */
/* Huvudbilden: så stor som möjligt (max 80 mm hög) utan att bladet blir längre än en A4.
   Utan JavaScript gäller CSS-höjden 58 mm. */
function fitMainImage() {
  var page = document.querySelector('.page');
  var box = page && page.querySelector('.mainimg');
  if (!box) return;
  var mm = 96 / 25.4, a4 = 297 * mm, h = 80;
  box.style.height = h + 'mm';
  while (page.getBoundingClientRect().height > a4 + 0.5 && h > 58) {
    h -= 2;
    box.style.height = h + 'mm';
  }
}
/* Produktbilderna har ofta breda vita kanter, så bänken ser liten ut även när rutan är stor.
   Beskär bort den vita kanten (med lite luft kvar) innan rutans höjd räknas ut.
   Bilden kommer från Shopifys CDN med CORS, därför crossorigin="anonymous" på img. Misslyckas det visas originalbilden. */
function trimMainImage() {
  return new Promise(function (resolve) {
    var img = document.querySelector('.page .mainimg img');
    if (!img || img.dataset.trimmed) return resolve();
    function run() {
      try {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) return resolve();
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, w, h);
        ctx.drawImage(img, 0, 0);
        var d = ctx.getImageData(0, 0, w, h).data;
        var top = h, left = w, right = -1, bottom = -1;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var i = (y * w + x) * 4;
            if (d[i] < 240 || d[i + 1] < 240 || d[i + 2] < 240) {
              if (x < left) left = x;
              if (x > right) right = x;
              if (y < top) top = y;
              if (y > bottom) bottom = y;
            }
          }
        }
        if (right < 0) return resolve();
        var pad = Math.round(Math.max(right - left, bottom - top) * 0.02);
        left = Math.max(0, left - pad); top = Math.max(0, top - pad);
        right = Math.min(w - 1, right + pad); bottom = Math.min(h - 1, bottom + pad);
        var cw = right - left + 1, ch = bottom - top + 1;
        if (cw * ch > w * h * 0.9) return resolve();
        var o = document.createElement('canvas');
        o.width = cw; o.height = ch;
        o.getContext('2d').drawImage(c, left, top, cw, ch, 0, 0, cw, ch);
        img.dataset.trimmed = '1';
        img.onload = function () { resolve(); };
        img.onerror = function () { resolve(); };
        img.removeAttribute('srcset');
        img.src = o.toDataURL('image/jpeg', 0.92);
      } catch (e) {
        resolve();
      }
    }
    if (img.complete) run(); else { img.addEventListener('load', run); img.addEventListener('error', function () { resolve(); }); }
  });
}
window.addEventListener('load', function () {
  var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
  Promise.all([fonts, trimMainImage()]).then(fitMainImage);
});
window.addEventListener('beforeprint', fitMainImage);

(function () {
  var btn = document.getElementById('pb-download');
  if (!btn) return;
  function load(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function imagesReady(root) {
    return Promise.all([].slice.call(root.querySelectorAll('img')).map(function (img) {
      return img.complete ? null : new Promise(function (r) { img.onload = img.onerror = r; });
    }));
  }
  btn.addEventListener('click', async function () {
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-busy');
    try {
      if (!window.html2canvas) await load('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
      if (!window.jspdf) await load('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
      if (document.fonts && document.fonts.ready) await document.fonts.ready;
      var page = document.querySelector('.page');
      await imagesReady(page);
      await trimMainImage();
      fitMainImage();
      var canvas = await window.html2canvas(page, {
        scale: 3, useCORS: true, backgroundColor: '#ffffff',
        windowWidth: 1000, scrollX: 0, scrollY: -window.scrollY
      });
      var pdf = new window.jspdf.jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4', compress: true });
      var w = 210, h = canvas.height * 210 / canvas.width, x = 0;
      if (h > 297) { w = w * 297 / h; h = 297; x = (210 - w) / 2; }
      pdf.addImage(canvas.toDataURL('image/jpeg', 0.92), 'JPEG', x, 0, w, h);
      pdf.save(btn.getAttribute('data-filename'));
    } catch (e) {
      console.error('Produktblad PDF', e);
      alert(btn.getAttribute('data-error'));
    } finally {
      btn.disabled = false;
      btn.textContent = label;
    }
  });
})();
